import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Row, Select, Divider, Image, Upload, Col } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getImageFallbackUrl } from '../../utils/helpers';

const { Option } = Select;

// TODO: Add dropdown for category

function CreateUpdateBrandForm({
  selectedBrandItem = {},
  tagList,
  categoryList,
  languageList,
  onSubmit,
}) {
  const isUpdate = !!selectedBrandItem?.id;
  const [imageUrl, setImageUrl] = useState();
  const [mainImageError, setMainImageError] = useState('');
  const [mainImageFileList, setMainImageFileList] = useState([]);
  const [failedMainImages, setFailedMainImages] = useState(new Set()); // Track failed main images

  useEffect(() => {
    selectedBrandItem.image && setImageUrl(selectedBrandItem.image);
  }, [selectedBrandItem]);

  function getBase64(img, callback) {
    if (!(img instanceof Blob)) {
      console.error('getBase64: img is not a Blob:', img);
      return;
    }
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.addEventListener('error', (error) => console.error('FileReader error:', error));
    reader.readAsDataURL(img);
  }

  const handleSubmit = async values => {
    // Get the main image file if it exists and structure it as expected
    const mainImageFile = mainImageFileList.length > 0 ? mainImageFileList[0] : null;

    values = {
      ...values,
      // Structure the main image as expected by the backend
      image: mainImageFile ? { file: { originFileObj: mainImageFile.originFileObj } } : undefined,
    };

    onSubmit(values);
  };

  const handleImageChange = info => {
    console.log('handleImageChange called with:', info);

    // Get the current file being processed
    const file = info.file;

    // Check if we have a valid file to process
    if (file && (file.originFileObj || file.uid)) {
      console.log('Processing file:', file.name, 'Size:', file.size, 'Type:', file.type);

      // Update the file list
      setMainImageFileList(info.fileList);

      // If we have originFileObj, convert to base64 for preview
      if (file.originFileObj) {
        getBase64(file.originFileObj, result => {
          console.log('Base64 conversion successful, setting imageUrl');
          setImageUrl(result);
        });
      } else if (file.url || file.thumbUrl || file.preview) {
        // Use existing URL/preview if available
        setImageUrl(file.url || file.thumbUrl || file.preview);
      }

      setMainImageError('');
    } else if (info.fileList.length === 0) {
      // Handle file removal
      setMainImageFileList([]);
      setImageUrl('');
      setMainImageError('');
    }
  };

  // Handle main image error - try fallback URL
  const handleMainImageError = (imageUrl) => {
    if (!failedMainImages.has(imageUrl)) {
      setFailedMainImages(prev => new Set([...prev, imageUrl]));
    }
  };

  const beforeUploadMainImage = file => {
    const MAX_SIZE_BYTES = 0.75 * 1024 * 1024; // 0.75 MB
    const hasImageMimeType = file.type && file.type.startsWith('image/');
    const hasImageExtension = /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(file.name || '');
    const isImage = hasImageMimeType || hasImageExtension;

    if (!isImage) {
      setMainImageError('Only image files are allowed (jpg, png, gif, webp, bmp, svg).');
      return Upload.LIST_IGNORE;
    }

    if (typeof file.size === 'number' && file.size > MAX_SIZE_BYTES) {
      setMainImageError('Image must be 0.75 MB or smaller.');
      return Upload.LIST_IGNORE;
    }

    setMainImageError('');
    return false; // prevent auto upload, allow adding to list
  };

  const handleMainImageRemove = file => {
    setMainImageFileList([]);
    setImageUrl('');
    setMainImageError('');
    return true;
  };

  return (
    <Form
      onFinish={handleSubmit}
      name="createUpdateBrandForm"
      className="form-wrapper"
      layout="vertical"
      size="large"
      initialValues={selectedBrandItem}
    >
      <Row>
        <Col span={12}>
          {languageList.map(lan => (
            <Form.Item
              key={lan.id}
              name={`name.${lan.id}`}
              label={`Name in ${lan.name}`}
              rules={[{ required: true, message: `Please enter ${lan.name} brand name!` }]}
            >
              <Input placeholder={`brand name in ${lan.name}`} />
            </Form.Item>
          ))}
        </Col>
      </Row>
      <Divider />
      {/* <Row>
        <Col span={12}>
          <Form.Item
            label="Tag"
            name="tagIds"
            rules={[{ required: true, message: 'Please select the tag!' }]}>
            <Select placeholder="Select a tag" mode="multiple">
              {tagList.map(tag => (
                <Option value={tag.id} key={tag.id}>
                  {tag.translations.map((translation, index) => (
                    <>
                      {translation.lanName}: <b>{translation.name}</b>{' '}
                      {index !== tag.translations.length - 1 && '- '}
                    </>
                  ))}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Divider /> */}
      <Row>
        <Col span={12}>
          <Form.Item label="Brand Image:" name="image" className="product-image-upload">
            <Upload
              listType="picture-card"
              fileList={mainImageFileList}
              onPreview={file => console.log(file)}
              onChange={handleImageChange}
              beforeUpload={beforeUploadMainImage}
              onRemove={handleMainImageRemove}
              accept="image/*"
              maxCount={1}
              showUploadList={true}
            >
              {imageUrl ? (
                <Image
                  src={failedMainImages.has(imageUrl) ? getImageFallbackUrl(imageUrl) : imageUrl}
                  alt="avatar"
                  style={{ width: '100%' }}
                  preview={false}
                  onError={() => handleMainImageError(imageUrl)}
                />
              ) : (
                <>
                  <PlusOutlined type="plus" />
                  <div className="ant-upload-text">Upload</div>
                </>
              )}
            </Upload>
            {mainImageError ? (
              <div style={{ color: '#ff4d4f', marginTop: 8 }}>{mainImageError}</div>
            ) : null}
          </Form.Item>
        </Col>
      </Row>

      <Row className="m-t-30 f-r">
        <Form.Item>
          <Button type="primary" htmlType="submit" size="large" disabled={!!mainImageError}>
            Save
          </Button>
        </Form.Item>
      </Row>
    </Form>
  );
}

export default CreateUpdateBrandForm;
